import querystring from 'query-string';

import { genericApiGenerated } from './genericApiGenerated';

export const enhancedApi = genericApiGenerated.enhanceEndpoints({
  addTagTypes: ['Mall', 'Retailer', 'Product'],
  endpoints: {
    mallServiceListMalls: {
      providesTags: (result, error, arg) =>
        result && result.malls
          ? [
              ...result.malls.map(({ name }) => ({
                type: 'Mall' as const,
                id: name
              })),
              'Mall'
            ]
          : ['Mall']
    },
    mallServiceGetMall: {
      providesTags: (result, error, arg) =>
        result && result.name
          ? [{ type: 'Mall' as const, id: result.name }]
          : ['Mall']
    },
    mallServiceCreateMall: {
      invalidatesTags: ['Mall']
    },
    mallServiceDeleteMall: {
      invalidatesTags: ['Mall']
    },
    mallServiceUpdateMall: {
      invalidatesTags: (result, error, arg) => {
        return result && result.name
          ? [{ type: 'Mall', id: result?.name }]
          : ['Mall'];
      }
    },
    // retailerServiceBatchGetRetailers: {
    //   query: (arg: string) => {
    //     return `/v1/retailers:batchGet?${querystring.stringify(arg)}`;
    //   },
    //   providesTags: (result: any, error: any, arg: any) =>
    //     result && result.retailers
    //       ? [
    //           ...result.retailers.map(({ name }: any) => ({
    //             type: 'Retailer' as const,
    //             id: name
    //           })),
    //           'Retailer'
    //         ]
    //       : ['Retailer']
    // },
    retailerServiceUpdateRetailer: {
      invalidatesTags: (result, error, arg) => {
        return result && result.name
          ? [{ type: 'Retailer', id: result?.name }]
          : ['Retailer'];
      }
    },
    // productServiceBatchGetProducts: {
    //   query: (arg: any) => {
    //     return `/v1/products:batchGet?${querystring.stringify(arg)}`;
    //   },
    //   providesTags: (result: any, error: any, arg: any) =>
    //     result && result.products
    //       ? [
    //           ...result.products.map(({ name }: any) => ({
    //             type: 'Product' as const,
    //             id: name
    //           })),
    //           'Product'
    //         ]
    //       : ['Product']
    // },
    productServiceUpdateProduct: {
      invalidatesTags: (result, error, arg) => {
        return result && result.name
          ? [{ type: 'Product', id: result?.name }]
          : ['Product'];
      }
    }
  }
});
